import "selectric";

export default function selectWithSelectric() {
  $(".js-select-selectric").selectric();
}

selectWithSelectric();
